import {
  LearnersChangeWishlistsChangeWishlist,
  LearnersChangeWishlistsChangeWishlistClassInformationTrait,
  LearnersChangeWishlistsChangeWishlistItemsTrait,
  LearnersChangeWishlistsChangeWishlistStateTrait,
  LearnersChangeWishlistsChangeWishlistStudentInformationTrait,
} from "@/types/serializers"
import { useProps } from "@/lib/page-rendering"
export type EditProps = {
  change_wishlist: LearnersChangeWishlistsChangeWishlist &
    LearnersChangeWishlistsChangeWishlistClassInformationTrait &
    LearnersChangeWishlistsChangeWishlistStudentInformationTrait &
    LearnersChangeWishlistsChangeWishlistItemsTrait &
    LearnersChangeWishlistsChangeWishlistStateTrait
}

export const useEditProps = () => useProps<EditProps>()
